import React from "react";
import { FiDownload, FiFileText, FiCalendar, FiCheckCircle } from "react-icons/fi";

const FORMAT_COLORS = { PDF: "#ef4444", CSV: "#10b981", Excel: "#3b82f6" };

const SCHEDULED_REPORTS = [
  { id: "SR-01", name: "Daily Operations Summary", freq: "Daily 06:00", recipients: "ops-team@stp.local", lastSent: "Today 06:00", status: "Active" },
  { id: "SR-02", name: "MPCB Compliance Report",   freq: "Monthly 1st",  recipients: "compliance@stp.local", lastSent: "01 Feb 2026", status: "Active" },
  { id: "SR-03", name: "Energy Consumption Report", freq: "Weekly Mon",   recipients: "admin@stp.local",     lastSent: "24 Feb 2026", status: "Active" },
  { id: "SR-04", name: "Sludge Disposal Log",       freq: "Weekly Fri",   recipients: "maintenance@stp.local", lastSent: "21 Feb 2026", status: "Paused" },
];

const StpReportsPanel = ({ d }) => (
  <div className="stp-reports-panel">

    <div className="stp-section-title">Reports &amp; Data Export</div>
    <div className="stp-section-sub">Download STP operational reports in PDF, CSV or Excel format</div>

    {/* Report cards */}
    <div className="stp-report-grid">
      {d.reports.map(r => (
        <div key={r.id} className="stp-report-card">
          <div className="stp-rc-top">
            <FiFileText size={20} color="#667eea" />
            <div>
              <div className="stp-rc-name">{r.name}</div>
              <div className="stp-rc-desc">{r.desc}</div>
            </div>
          </div>
          <div className="stp-rc-footer">
            <span className="stp-rc-gen">Generated: {r.generated}</span>
            <div className="stp-rc-btns">
              {r.formats.map(fmt => (
                <button
                  key={fmt}
                  className="stp-dl-btn"
                  style={{ background: FORMAT_COLORS[fmt] + "18", color: FORMAT_COLORS[fmt], borderColor: FORMAT_COLORS[fmt] }}
                >
                  <FiDownload size={12} /> {fmt}
                </button>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Scheduled Reports */}
    <div className="stp-section-title" style={{ marginTop: 24 }}>
      <FiCalendar size={15} style={{ marginRight: 6, verticalAlign: "middle" }} />
      Scheduled Auto-Reports
    </div>
    <div className="stp-sched-report-table">
      <div className="stp-srt-header">
        <span>Report Name</span>
        <span>Frequency</span>
        <span>Recipients</span>
        <span>Last Sent</span>
        <span>Status</span>
      </div>
      {SCHEDULED_REPORTS.map(sr => (
        <div key={sr.id} className="stp-srt-row">
          <span className="stp-srt-name">{sr.name}</span>
          <span style={{ fontSize: 12, color: "#6b7280" }}>{sr.freq}</span>
          <span style={{ fontSize: 11, color: "#9ca3af" }}>{sr.recipients}</span>
          <span style={{ fontSize: 12, color: "#6b7280" }}>{sr.lastSent}</span>
          <span className={`stp-badge ${sr.status === "Active" ? "stp-badge-green" : "stp-badge-gray"}`}>
            {sr.status === "Active" && <FiCheckCircle size={11} style={{ marginRight: 3 }} />}
            {sr.status}
          </span>
        </div>
      ))}
    </div>

    {/* Compliance note */}
    <div className="stp-compliance-note">
      <FiFileText size={14} color="#667eea" />
      All reports are generated from live SCADA data and archived for 5 years as per MPCB audit requirements.
      Contact your admin to configure custom report schedules or add recipients.
    </div>
  </div>
);

export default StpReportsPanel;
